interface SessionState {
  status:
    "anonymous" | "exchanging" | "authenticated" | "expired" | "unavailable";
  workspaceId?: string;
  retryAfterSeconds?: number;
}

const exchanges = new Map<string, Promise<SessionState>>();

export function exchangeTelegramSession(
  initData: string,
  fetcher: typeof fetch = fetch,
): Promise<SessionState> {
  const pending = exchanges.get(initData);
  if (pending) return pending;
  const exchange = performExchange(initData, fetcher);
  exchanges.set(initData, exchange);
  const clear = () => {
    if (exchanges.get(initData) === exchange) exchanges.delete(initData);
  };
  void exchange.then(clear, clear);
  return exchange;
}

async function performExchange(
  initData: string,
  fetcher: typeof fetch,
): Promise<SessionState> {
  const response = await fetcher("/api/v1/sessions/telegram", {
    method: "POST",
    credentials: "include",
    headers: { "X-Telegram-Init-Data": initData },
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403)
      return { status: "anonymous" };
    const retryAfterHeader = response.headers.get("retry-after");
    const retryAfter =
      retryAfterHeader === null ? NaN : Number(retryAfterHeader);
    return {
      status: "unavailable",
      retryAfterSeconds:
        Number.isFinite(retryAfter) && retryAfter >= 0 ? retryAfter : undefined,
    };
  }
  let body: unknown;
  try {
    body = await response.json();
  } catch {
    return { status: "unavailable" };
  }
  if (
    typeof body !== "object" ||
    body === null ||
    !("workspace_id" in body) ||
    typeof body.workspace_id !== "string" ||
    body.workspace_id.length === 0
  )
    return { status: "anonymous" };
  return { status: "authenticated", workspaceId: body.workspace_id };
}
